import { render, staticRenderFns } from "./AddORAskIQButton.vue?vue&type=template&id=34b64afa&scoped=true"
import script from "./AddORAskIQButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddORAskIQButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddORAskIQButton.vue?vue&type=style&index=0&id=34b64afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b64afa",
  null
  
)

export default component.exports